const slime = (level) => {
  const handle = 'slime';
  const types = ['amorphous', 'jelly', 'poisonous'];
  const AI_PRIORITIES = ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'];
  const equipped_abilities = [{ value: 'move' }, { value: 'melee_attack' }, { value: 'fumigate' }];
  const bags = [];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'slime_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          fumigate: {
            handle: 'fumigate',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(1 + bound_level * 0.25 + Math.random() * 3),
      perception: Math.round(1 + bound_level * 0.1 + Math.random() * 3),
      mana: Math.round(2 + bound_level * 0.3 + Math.random() * 3),
      toughness: Math.round(6 + bound_level * 1.0 + Math.random() * 3),
      strength: Math.round(4 + bound_level * 0.5 + Math.random() * 3),
      willpower: Math.round(7 + bound_level * 1.1 + Math.random() * 3),
      dexterity: Math.round(1 + bound_level * 0.1 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 165,
    drops_gold: false,
    drops_equipment: false,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: {},
      equipped_abilities,
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = slime;
